import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

const OrderManagementApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.ORDER_MANAGEMENT}
      scope='order_management'
      envKey={apps[AppId.ORDER_MANAGEMENT].runtimeEnvKey}
      entryPath='./OrderManagementApp'
      url={process.env.REACT_APP_ORDER_MANAGEMENT_APP_DEV_PATH}
      cdnUrl={apps[AppId.ORDER_MANAGEMENT].cdnUrl}
      appName={apps[AppId.ORDER_MANAGEMENT].name}
      appProps={{
        user,
        history,
        appPath: apps[AppId.ORDER_MANAGEMENT].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location
          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { OrderManagementApp }
